module.exports = __webpack_public_path__ + "assets/img/old_user.7170936d.png";